import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Initialize Sentry as early as possible so we capture errors that fire
// during initial render. The DSN comes from a build-time env var
// (set in .env.local for dev, in your hosting platform's env settings
// for production). With no DSN set we skip init entirely so dev stays
// quiet and CI builds without the env var compile cleanly.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    // Light browser performance tracing — calculator is mostly client-side
    // math, so we don't need a heavy sample rate.
    tracesSampleRate: 0.1,
    // Session replays only when an error fires — gives us a video-like
    // reconstruction of what the user was doing without privacy noise.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    // Filter out the well-known harmless noise.
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
    ],
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ErrorBoundary>
);
